<template>
    <BreadCrumb PageTitle="Detail usager" />
    <ViewUsager/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
      import ViewUsager from "@/components/Usager/ViewUsager.vue";
  
    export default defineComponent({
      name: "ViewUsagerPage",
      components: {
        BreadCrumb,
        ViewUsager,
      },
    });
  </script>